"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkOrderError = void 0;
var BulkOrderError;
(function (BulkOrderError) {
    BulkOrderError["INVALID_COUNTRY_CODE"] = "INVALID_COUNTRY_CODE";
    BulkOrderError["INVALID_SERVICE_LEVEL_NOT_AKHI_OTHER"] = "INVALID_SERVICE_LEVEL_NOT_AKHI_OTHER";
    BulkOrderError["INVALID_SERVICE_LEVEL_NOT_DOMESTIC"] = "INVALID_SERVICE_LEVEL_NOT_DOMESTIC";
    BulkOrderError["INVALID_SERVICE_LEVEL_NOT_MILITARY"] = "INVALID_SERVICE_LEVEL_NOT_MILITARY";
    BulkOrderError["INVALID_SERVICE_LEVEL_NOT_STANDARD"] = "INVALID_SERVICE_LEVEL_NOT_STANDARD";
    BulkOrderError["INVALID_SERVICE_LEVEL_NOT_WORLDWIDE"] = "INVALID_SERVICE_LEVEL_NOT_WORLDWIDE";
    BulkOrderError["INVALID_DSKU"] = "INVALID_DSKU";
    BulkOrderError["INVALID_SERVICE_LEVEL"] = "INVALID_SERVICE_LEVEL";
    BulkOrderError["MISSING_CITY"] = "MISSING_CITY";
    BulkOrderError["MISSING_COUNTRY"] = "MISSING_COUNTRY";
    BulkOrderError["MISSING_FIRST_AND_LAST_NAME"] = "MISSING_FIRST_AND_LAST_NAME";
    BulkOrderError["MISSING_QUANTITY"] = "MISSING_QUANTITY";
    BulkOrderError["MISSING_STREET_1"] = "MISSING_STREET_1";
    BulkOrderError["NO_ITEMS"] = "NO_ITEMS";
    BulkOrderError["QUANTITY_NOT_POSITIVE"] = "QUANTITY_NOT_POSITIVE";
    BulkOrderError["QUANTITY_NOT_INTEGER"] = "QUANTITY_NOT_INTEGER";
})(BulkOrderError = exports.BulkOrderError || (exports.BulkOrderError = {}));
//# sourceMappingURL=BulkOrder.js.map